export const NEW_ITEM_ID = '__new__'
export const EDITION_MODE_ROUTE = 'editar'
export const CREATION_MODE_ROUTE = 'crear'
export const DUPLICATION_MODE_ROUTE = 'duplicar'
export const VIEW_MODE_ROUTE = 'ver'
export const TIPO_0KM = '0km'
export const SALE_TYPE_VO = 'VO'
